import API from "./index"

export const getCurrentCalendar = () => API.get(`/calendar/admin`)